import { __extends } from "tslib";
import { getLightElement, notChildEventListener } from '@tyler-components-web/core';
import { getActiveElement } from 'shadow-utils';
import { AVATAR_CONSTANTS } from '../../avatar';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { PopupAnimationType, PopupPlacement, POPUP_CONSTANTS } from '../../popup';
import { PROFILE_CARD_CONSTANTS } from '../profile-card';
import { OMNIBAR_PROFILE_BUTTON_CONSTANTS } from './omnibar-profile-button-constants';
var OmnibarProfileButtonAdapter = /** @class */ (function (_super) {
    __extends(OmnibarProfileButtonAdapter, _super);
    function OmnibarProfileButtonAdapter(component) {
        return _super.call(this, component) || this;
    }
    OmnibarProfileButtonAdapter.prototype.initialize = function () {
        this._avatarElement = getLightElement(this._component, AVATAR_CONSTANTS.elementName);
        this._buttonElement = getLightElement(this._component, OMNIBAR_PROFILE_BUTTON_CONSTANTS.selectors.BUTTON);
    };
    OmnibarProfileButtonAdapter.prototype.setClickListener = function (listener) {
        this._component.addEventListener('click', listener);
    };
    OmnibarProfileButtonAdapter.prototype.removeClickListener = function (listener) {
        this._component.removeEventListener('click', listener);
    };
    OmnibarProfileButtonAdapter.prototype.openPopup = function (profileCardConfig, dismissListener, profileListener, signOutListener, profileCardContent) {
        var _this = this;
        var profileCardElement = document.createElement(PROFILE_CARD_CONSTANTS.elementName);
        profileCardElement.fullName = profileCardConfig.fullName;
        profileCardElement.email = profileCardConfig.email;
        profileCardElement.signOut = profileCardConfig.signOut;
        profileCardElement.profile = profileCardConfig.profile;
        profileCardElement.avatarText = profileCardConfig.avatarText;
        profileCardElement.avatarImageUrl = profileCardConfig.avatarImageUrl;
        profileCardElement.avatarLetterCount = profileCardConfig.avatarLetterCount;
        profileCardElement.addEventListener(PROFILE_CARD_CONSTANTS.events.PROFILE, function () { return profileListener(); });
        profileCardElement.addEventListener(PROFILE_CARD_CONSTANTS.events.SIGN_OUT, function () { return signOutListener(); });
        if (profileCardContent) {
            profileCardElement.appendChild(profileCardContent);
        }
        this._popupElement = document.createElement(POPUP_CONSTANTS.elementName);
        this._popupElement.targetElement = this._component;
        this._popupElement.placement = PopupPlacement.BottomRight;
        this._popupElement.animationType = PopupAnimationType.Menu;
        this._popupElement.appendChild(profileCardElement);
        this._popupElement.open = true;
        return notChildEventListener(this._popupElement, function (activeElement) {
            if (!_this._popupElement) {
                return;
            }
            if (!_this._component.contains(getActiveElement())) {
                dismissListener();
            }
        }, true);
    };
    OmnibarProfileButtonAdapter.prototype.closePopup = function () {
        if (this._popupElement) {
            this._popupElement.open = false;
        }
    };
    OmnibarProfileButtonAdapter.prototype.requestFocus = function () {
        this._buttonElement.focus();
    };
    OmnibarProfileButtonAdapter.prototype.setAvatarText = function (value) {
        this._avatarElement.text = value;
    };
    OmnibarProfileButtonAdapter.prototype.setAvatarLetterCount = function (value) {
        this._avatarElement.letterCount = value;
    };
    OmnibarProfileButtonAdapter.prototype.setAvatarImageUrl = function (value) {
        this._avatarElement.imageUrl = value;
    };
    return OmnibarProfileButtonAdapter;
}(BaseAdapter));
export { OmnibarProfileButtonAdapter };
